import {React, useState,useEffect} from 'react';
import { useSelector } from 'react-redux';
import { getAllProducts } from '../../features/productSlice/productSlice';
import { isDataLoaded } from '../../features/productSlice/productSlice';
import {useParams, useHistory} from "react-router-dom";
import auth from '../../common/api/Firebase';
import axios from "axios";
import { addProducts } from '../../features/productSlice/productSlice';
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import "./ProductDetail.scss";







  // console.log("signed In");





const ProductDetail = () => {

    const dispatch = useDispatch();
    const dataLoaded = useSelector(isDataLoaded);
    let { prdID } = useParams();
    let history = useHistory();

    
const fetchData = async  () => {

     

    const data = await 
    axios.get(`https://med-fashion-default-rtdb.firebaseio.com/Products.json`)
    .then(function (response) {
      // handle success
       dispatch(addProducts(response.data));
      // console.log(response.data);
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    });
    history.push("/");
  
  };


    // const [data,setMyData] = useState([]);
     
    useEffect(() => {
        //Start Login
       
    
        // Sign in Anonymously to the Firebase
        const signin = () => {
            auth.signInAnonymously().then(() => {
        // declare the data fetching function
        const fetchData = async () => {
          const data = await 
          axios.get(`https://med-fashion-default-rtdb.firebaseio.com/Products/${prdID}.json`)
          .then(function (response) {

            if(response.data){
                dispatch(addProducts(response.data));
             
              } else {
                history.push("/PageNotFound");
            // handle success
          
              }
            // console.log(response.data);
          })
          .catch(function (error) {
            // handle error
           console.log(error);
        
          });

        
        
        };
    
        // console.log("signed In");
     fetchData();
              })
            .catch(alert);
        }
       signin();
        // End Login 
    
         },[]);

       
         const data = useSelector(getAllProducts);
         const [qty,setQty] = useState(1);

        //  console.log(data)
    //Get Quantity value
    const qtyChange = (e)=>{
setQty(e.target.value)
    }
    const chat = ()=>{
        window.location.replace(`https://wa.me/447466207558?text=%20Hi%20MedFashion_Stores,%20I%20want%20to%20buy%20${data.product_name}%20,%20Price(for_one):£${data.price}%20,%20QTY_needed:%20${qty}%20,%20Product_ID:%20${data.timestamp}`)
 
        // alert(data.product_name)
    
    }
    // console.log(prdID);
   

    return (
      
        <div className='container mb-3'>
            <div >
           
                { dataLoaded==true &&
                   
                    (
                    <div className='row'>
                    <div className='col-sm-5 offset-1 pimage'>
                        <img src={data.image_url} />
                        </div>
                        <div className='col-sm-4'>
                            <div onClick={fetchData} className="btn btn-outline-info"><i className='fas fa-arrow-alt-circle-left'></i>
                          
                         
                           <span className="lead">   Back</span>
                            </div>
                            <div className='lead'>{data.product_name}  </div>
                                <hr />
                                <div >{data.address}</div>
                                <div className="mb-0 pb-2">
                             
                                    <div className='lead btn btn-outline-warning'>
                                  
                                    &#163; {data.price}</div>
                                    

                                    <hr />
                                    <div className='d-flex justify-content-around'>
                                    <span className="lead"> Quantity</span>
                                  
                                    <input value={qty} onChange={qtyChange} style={{"width":"50px"}}className='form-control' type="number" />
                                    
                                    <button onClick={chat} className='btn btn-outline-success mb-2'><span>
                                         Order Via 
                                  
                                         </span>   
                                    <i className="fa fa-whatsapp" aria-hidden="true"></i>
                                    </button>
                                    </div>
                                </div>
                              
                            </div>
                        </div>
                      )
                        
                } 
                {dataLoaded==false &&
                      <h6>Product Detail loading..</h6>
                      }
                
         
           

      
            </div>
          
        </div>
    );
};

export default ProductDetail;